import React, { useState, useEffect } from 'react'
import { IResponse, IQuestionOption } from 'models'
import { IQuestionProps } from './Question'
import { Heading, Text, Box, Checkbox, Flex } from 'components'

const QuestionMulti = ({ question, onChange }: IQuestionProps) => {
  const [answers, setAnswers] = useState<IResponse<'multi'>['answers']>([])

  const colorAccent = question.theming ? question.theming.accent : 'light'
  // Body parts "ways" question are limited to 5
  const limit =
    question.category && question.question.includes('ways') ? 5 : undefined

  const isChecked = (option: IQuestionOption) =>
    Boolean(answers.find((a) => a.value === option.value))

  const isLimited = (option: IQuestionOption) =>
    limit && answers.length >= limit && !isChecked(option)

  const handleCheckboxClick = (option: IQuestionOption) => {
    if (isLimited(option)) return

    let newAnswers: IResponse<'multi'>['answers'] = []
    if (!isChecked(option)) {
      newAnswers = answers.concat({ value: option.value })
      setAnswers(newAnswers)
    } else {
      newAnswers = answers.filter((answer) => answer.value !== option.value)
      setAnswers(newAnswers)
    }
    onChange(newAnswers)
  }

  // reset answers to empty everytime a question changed
  useEffect(() => {
    setAnswers([])
  }, [question])

  return (
    <Flex
      width={1}
      flexDirection='column'
      justifyContent={['end', 'end', 'center']}
    >
      <Box
        width={1}
        marginBottom={[2, 3]}
        marginLeft={[1]}
        textAlign={['left', null, 'center']}
      >
        <Heading
          uiColorTheme={colorAccent}
          paddingRight={[1, 2]}
          fontSize={['1.6em', '1.8em', '2.2em', '2.4em']}
          as='h2'
          lineHeight='1.25'
        >
          {question.question}
        </Heading>
        <Text uiColorTheme={colorAccent} fontSize={['0.8em', null, '1em']}>
          (Choose {limit ? 'up to 5' : 'as many as you want'})
        </Text>
      </Box>
      <Box width={1} textAlign={['left', 'left', 'center']}>
        {question.options &&
          question.options.map((option, index) => (
            <Checkbox
              uiColorTheme={colorAccent}
              key={`${question.type}_${question.id}_option_${index}`}
              checked={isChecked(option)}
              disabled={isLimited(option)}
              padding={['12px', null, '14px']}
              margin={['6px', null, '8px']}
              fontSize={['12px', null, '15px']}
              onChange={() => handleCheckboxClick(option)}
            >
              {option.value}
            </Checkbox>
          ))}
      </Box>
    </Flex>
  )
}

export default QuestionMulti
